module.exports = __webpack_public_path__ + "img/deco-tree.4edf3d5c.png";